const _excluded = ["page"];var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { withRouter } from "../componentWrappers";
import { RequestParams } from "../utils/RequestParams";
import { actions } from "../BasicReducer";
import { isClient, events } from "../utils";
import { toUrlParams } from "../../shared/JSONRequest";
import { ConnectedViewer as Viewer } from "./components/Viewer";
import entitiesAPI from "../Entities/EntitiesAPI";
import { leaveEditMode } from "./actions/documentActions";
import { searchParamsFromSearchParams } from "../utils/routeHelpers";
import { scrollToPage, activateReference } from "./actions/uiActions";
import { requestViewerState } from "./actions/routeActions";

const defaultDoc = (entity) => entity.get('defaultDoc') ? entity.get('defaultDoc').toJS() : {};

class PDFViewComponent extends Component {
  static async requestState(requestParams, globalResources) {
    return requestViewerState(
      requestParams.add({ raw: requestParams.data.raw === 'true' || !isClient }),
      globalResources
    );
  }

  constructor(props, context) {
    super(props, context);
    this.changeBrowserHistoryPage = this.changeBrowserHistoryPage.bind(this);
    this.changePage = this.changePage.bind(this);
    this.onDocumentReady = this.onDocumentReady.bind(this);
  }

  componentDidMount() {
    const query = searchParamsFromSearchParams(this.props.searchParams);
    if (query.searchTerm) {
      this.context.store.dispatch(actions.set('viewer.sidepanel.tab', 'text-search'));
    }
  }

  componentWillReceiveProps(props) {
    const currentQuery = searchParamsFromSearchParams(this.props.searchParams);
    const query = searchParamsFromSearchParams(props.searchParams);

    if (query.page !== currentQuery.page && query.raw !== 'true') {
      this.changePage(query.page);
    }
    if (
    (query.page !== currentQuery.page || query.raw !== currentQuery.raw) &&
    query.raw === 'true')
    {
      entitiesAPI.
      getRawPage(new RequestParams({ _id: defaultDoc(props.entity)._id, page: query.page })).
      then((pageText) => {
        this.context.store.dispatch(actions.set('viewer/rawText', pageText));
      });
    }
  }

  componentWillUnmount() {
    this.props.leaveEditMode();
  }

  onDocumentReady(doc) {
    events.emit('documentLoaded');
    const query = searchParamsFromSearchParams(this.props.searchParams);

    if (query.raw === 'true') {
      return;
    }
    if (query.page) {
      scrollToPage(query.page, 0);
    }
    const { ref } = query;
    if (ref) {
      const reference = doc.get('relations').find((r) => r.get('_id') === ref);
      this.context.store.dispatch(activateReference(reference.toJS()));
    }
  }

  changePage(nextPage) {
    const { raw = 'false' } = searchParamsFromSearchParams(this.props.searchParams);

    const notRaw = String(raw).toLowerCase() === 'false';
    if (notRaw) {
      return scrollToPage(nextPage);
    }

    return this.changeBrowserHistoryPage(nextPage, notRaw);
  }

  changeBrowserHistoryPage(newPage, replace = true) {
    const _searchParamsFromSear = searchParamsFromSearchParams(this.props.searchParams),{ page } = _searchParamsFromSear,queryWithoutPage = _objectWithoutProperties(_searchParamsFromSear, _excluded);

    this.props.navigate(
      `${this.props.location.pathname}${toUrlParams(_objectSpread(_objectSpread({}, queryWithoutPage), {}, { page: newPage }))}`,
      { replace }
    );
  }

  render() {
    const query = searchParamsFromSearchParams(this.props.searchParams);
    const page = Number(query.page || 1);
    const { filename } = defaultDoc(this.props.entity);
    const sharedId = this.props.entity.get('sharedId');
    const raw = query.raw === 'true' || !isClient;

    return /*#__PURE__*/(
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(Helmet, {}, void 0,
      raw && /*#__PURE__*/
      _jsx("link", { rel: "canonical", href: `/entity/${sharedId}?page=${page}&file=${filename}` })

      ), /*#__PURE__*/
      _jsx(Viewer, {
        raw: raw,
        searchTerm: query.searchTerm,
        onPageChange: this.changeBrowserHistoryPage,
        onDocumentReady: this.onDocumentReady,
        changePage: this.changePage,
        page: page,
        file: defaultDoc(this.props.entity) }
      )
      ));

  }
}

PDFViewComponent.contextTypes = {
  store: PropTypes.instanceOf(Object)
};












PDFViewComponent.defaultProps = {
  leaveEditMode: () => {}
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ leaveEditMode }, dispatch);
}

const SSRPDFView = connect(null, mapDispatchToProps)(withRouter(PDFViewComponent));
const PDFView = Object.assign(SSRPDFView, { requestState: PDFViewComponent.requestState });
export { PDFView, PDFViewComponent };